import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/OcqZtNfbuEg?si=fLNhprl-3fDWvoa2"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/5v0XLjePZ-I?si=44MfR31FgaYuJbhq"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/rB6yaMonS_0?si=3kjktq8CKMAmzfth"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/QeH2jPqZGw4?si=BY4xXZSaD-LqUESq"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
];

function CorporateVideo() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Corporate Video Productions"
        para="Welcome to our corporate video production playlist, where excellence meets innovation!

Join us as we showcase the power of visual storytelling in the business world, highlighting the success stories, brand identities, and corporate messages of leading companies. From impactful employee training videos to captivating promotional content, our videos are tailored to elevate your brand and leave a lasting impression."
      />
      <VideoCareer videos={videos} />

      {/* <FourthPage /> */}
    </div>
  );
}

export default CorporateVideo;
